const isChangeLang = true;
const headerTextFlag = true;

export const environment = {
	isChangeLang,
	production: true,
	headerTextFlag
};
